<template>
  <a href="#" @click.prevent="navigate">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'MdxLink',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    navigate() {
      // Use Vue Router's programmatic navigation to ensure it works
      this.$router.push(this.to).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
  },
};
</script>
